/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TextDisplay/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TextDisplay({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity/ActivityType/Log/ToPart/TextDisplay"
  
}) {
let constantData = 'to'
let constantData1 = '‎'
let aggregateData = fromAggregate.join(constantData, constantData1)
let activityTextpartsToValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.to',
})
let activityTextpartsNotoValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.noTo',
})
let aggregateData1 = fromHelpers.showToPrefix(activityTextpartsToValueData, activityTextpartsNotoValueData)
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let activityTextpartsToValueData1 = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.to',
})
let activityTextpartsToValueData2 = fromData.useDataFormat({ viewPath,
context: 'activity',
path: 'textParts.to',
format: fromHelpers.truncate,
})
let constantData2 = '‎'
let aggregateData2 = fromAggregate.join(activityTextpartsToValueData2, constantData2)
let activityTextpartsToValueData3 = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.to',
})
  return (<React.Fragment
>
<fromFlow.When is={aggregateData1}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 fontSize={dtTypographyFontsizeM}
 data="'to'"
 data="'‎'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 data="activity.textParts.to"
 data="activity.textParts.noTo"
 aggregate="./helpers.js showToPrefix"
/>
</fromFlow.When>
<fromFlow.When is={activityTextpartsToValueData3}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 weight="medium"
 fontSize={dtTypographyFontsizeM}
 data="activity.textParts.to"
 title={activityTextpartsToValueData1}
 data="activity.textParts.to"
 format="./helpers.js truncate"
 data="'‎'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData2}
 data="activity.textParts.to"
/>
</fromFlow.When>
{children}
</React.Fragment>)
}